import {clickOutside} from "./utils/clickOutside";

let clickOutsideEvent;

export function initDesktopHeaderSearch() {
  const search = document.querySelectorAll('.js-search')[0];
  const input = document.querySelectorAll('.js-search_input')[0];
  const searchReset = document.querySelectorAll('.js-search_reset')[0];


  if (!search || !input || !searchReset) {
    return;
  }

  input.value = "";

  searchReset.addEventListener('click', () => {
    toggleSearch(search, input);
  });

  search.addEventListener('submit', (event) => {
    const inputValue = input.value;

    if (!inputValue) {
      event.preventDefault();
    } else {
      handleFormSubmit(search, input.value);
    }
  });
}

function toggleSearch(searchElement, inputElement) {
  const activeClass = 'm-active';

  if (searchElement.classList.contains(activeClass)) {
    searchElement.classList.remove(activeClass);
    clickOutsideEvent && clickOutsideEvent();
    inputElement.value = "";

    setTimeout(function () {
      inputElement.blur();
    }, 800);
  } else {
    searchElement.classList.add(activeClass);

    clickOutsideEvent = clickOutside(searchElement, () => {
      toggleSearch(searchElement, inputElement);
    });

    setTimeout(function () {
      inputElement.focus();
    }, 800);
  }
}

function handleFormSubmit(form, val) {
  const params = new URLSearchParams();

  if (val) {
    // 's' is search parameter for BE side handling
    params.append('s', val);
  } else {
    return;
  }

  const actionUrl = `${window.location.origin}?${params.toString()}`;

  // Updated URL for appropriate redirection
  form.setAttribute('action', actionUrl);
}
